module.exports = __webpack_public_path__ + "media/flags/is-fa365b4a.svg";